const theme = {
    colors: {
        font: '#343434',
        light: '#BFBFBF',
        card: '#fff',
        primary: '#00B4FF',
        bg: '#FCFCFC'
    },
}

export default theme